import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SIZES } from '../helper';
import Text from '../Text';
const Root = styled(Text).withConfig({
  displayName: "MessageTitle__Root",
  componentId: "sc-hbeun7-0"
})(["margin-bottom:0;"]);
const MessageTitle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    size
  } = _ref;

  const resolveFont = size => {
    const font = {
      lg: Text.tokens.TEXT_LG_BOLD,
      md: Text.tokens.TEXT_MD_BOLD,
      sm: Text.tokens.TEXT_MD_BOLD
    };
    return font[size] ? font[size] : font.lg;
  };

  return children && /*#__PURE__*/React.createElement(Root, {
    ref: ref,
    token: resolveFont(size)
  }, children);
});
MessageTitle.display = 'MessageTitle';
MessageTitle.defaultProps = {
  children: null,
  size: SIZES.LG
};
process.env.NODE_ENV !== "production" ? MessageTitle.propTypes = {
  /**
   * @ignore
   * Sets the children, Usually is a string (internally)
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  size: PropTypes.oneOf([SIZES.SM, SIZES.MD, SIZES.LG])
} : void 0;
export default MessageTitle;